<template>
    <article class="message">
        <div class="message-body">
            <div class="columns">
                <div class="column is-one-quarter  text-center">
                    Total lots found: <strong>{{ totalLotsFound }}</strong>
                </div>
                <div class="column">
                    <div class="field is-grouped is-grouped-multiline">
                        <div v-if="getQueryBrand" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">{{ getQueryBrand }}</span>
                                <span class="tag is-delete is-danger" @click="removeBrandFromQuery"></span>
                            </div>
                        </div>
                        <div v-if="getQueryModels" v-for="name in getQueryModels" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary " v-html="name"></span>
                                <span class="tag is-delete is-danger" @click="removeModelFromQuery(name)"></span>
                            </div>
                        </div>
                        <div v-if="getQueryYearMin" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">YEAR START: {{ getQueryYearMin }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryYearMax" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">YEAR MAX: {{ getQueryYearMax }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryKmsMin" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">KM's START: {{ getQueryKmsMin | formatNumber}}</span>
                            </div>
                        </div>
                        <div v-if="getQueryKmsMax" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">KM's MAX: {{ getQueryKmsMax | formatNumber }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryChassis" v-for="chassis in getQueryChassis" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary " v-html="chassis"></span>
                                <span class="tag is-delete is-danger" @click="removeChassisFromQuery(chassis)"></span>
                            </div>
                        </div>
                        <div v-if="getQueryDates" v-for="date in getQueryDates" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">{{ date }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryLots" v-for="lot in getQueryLots" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">#{{ lot }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryCcMin" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">CC START: {{ getQueryCcMin }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryCcMax" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">CC MAX: {{ getQueryCcMax }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryTransmissions" v-for="trans in getQueryTransmissions" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">{{ trans }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryColors" v-for="color in getQueryColors" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">{{ color }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryGrades" v-for="grade in getQueryGrades" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">GRADE: {{ grade }}</span>
                            </div>
                        </div>
                        <div v-if="getQueryAuctionsHasYokohama" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">YOKOHAMA</span>
                            </div>
                        </div>
                        <div v-if="getQueryAuctionsHasOsaka" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">OSAKA</span>
                            </div>
                        </div>
                        <div v-if="getQueryAuctionsHasNagoya" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">NAGOYA</span>
                            </div>
                        </div>
                        <div v-if="getQueryAuctionsHasHakata" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-new-primary ">HAKATA</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        computed: {
            totalLotsFound () {
                return this.$store.getters.getTotalLots
            },
            getQueryBrand () {
                return this.$store.getters.getQueryCompanyId
            },
            getQueryModels () {
                return this.$store.getters.getQueryModels
            },
            getQueryYearMin () {
                return this.$store.getters.getQuery['yearMin']
            },
            getQueryYearMax () {
                return this.$store.getters.getQuery['yearMax']
            },
            getQueryKmsMin () {
                return this.$store.getters.getQuery['kmsMin']
            },
            getQueryKmsMax () {
                return this.$store.getters.getQuery['kmsMax']
            },
            getQueryChassis () {
                return this.$store.getters.getQuery['chassis']
            },
            getQueryDates () {
                return this.$store.getters.getQuery['dates']
            },
            getQueryLots () {
                return this.$store.getters.getQuery['lots']
            },
            getQueryCcMin () {
                return this.$store.getters.getQuery['ccMin']
            },
            getQueryCcMax () {
                return this.$store.getters.getQuery['ccMax']
            },
            getQueryTransmissions() {
                return this.$store.getters.getQuery['transmissions']
            },
            getQueryColors() {
                return this.$store.getters.getQuery['colors']
            },
            getQueryGrades() {
                return this.$store.getters.getQuery['grades']
            },
            getQueryAuctions() {
                return this.$store.getters.getQuery['auctions']
            },
            getQueryAuctionsHasYokohama() {
                return this.$store.getters.getQueryAuctionsHasRegion('YOKOHAMA')
            },
            getQueryAuctionsHasOsaka() {
                return this.$store.getters.getQueryAuctionsHasRegion('OSAKA')
            },
            getQueryAuctionsHasNagoya() {
                return this.$store.getters.getQueryAuctionsHasRegion('NAGOYA')
            },
            getQueryAuctionsHasHakata() {
                return this.$store.getters.getQueryAuctionsHasRegion('HAKATA')
            }
        },
        methods: {
            removeBrandFromQuery () {
                this.$store.dispatch('changeQueryCompanyId')
                this.$store.dispatch('fetchResults')
            },
            removeModelFromQuery (model) {
                this.$store.dispatch('removeModelFromQuery', model)
                this.$store.dispatch('fetchResults')
            },
            removeChassisFromQuery (chassis) {
                this.$store.dispatch('removeChassisFromQuery', chassis)
                this.$store.dispatch('fetchResults')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Result/SearchQuery.vue